module.exports = __webpack_public_path__ + "6516600cbc.woff";